import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Collapse } from 'reactstrap';
import classNames from 'classnames';
import { useAccordionItem } from './context.js';

var AccordionBody = function (_a) {
    var children = _a.children, className = _a.className, accordionId = _a.accordionId, _b = _a.tag, Tag = _b === void 0 ? 'div' : _b, attributes = __rest(_a, ["children", "className", "accordionId", "tag"]);
    var open = useAccordionItem(accordionId).open;
    return (jsx(Collapse, __assign({}, attributes, { className: "accordion-collapse", isOpen: open, "data-testid": "accordion-body-".concat(accordionId), role: "region" }, { children: jsx(Tag, __assign({ className: classNames('accordion-body', className) }, { children: children })) })));
};
AccordionBody.displayName = 'Accordion.Body';

export { AccordionBody };
